import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "../components/site/Layout";
import { blogPosts } from "../data/mock";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("ro-RO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/noutati" replace />;

  const others = blogPosts.filter((p) => p.slug !== slug).slice(0, 2);

  return (
    <>
      <section className="page-hero" style={{ paddingBottom: 48 }}>
        <div className="site-container" style={{ maxWidth: 860 }}>
          <div
            className="blog-card-meta"
            style={{ marginBottom: 14 }}
          >
            {post.category} · {formatDate(post.date)}
          </div>
          <h1 style={{ color: "var(--ce-heading)" }}>{post.title}</h1>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 48 }}>
        <div className="site-container" style={{ maxWidth: 860 }}>
          <Reveal>
            <img
              src={post.image}
              alt={post.title}
              className="article-hero-img"
              style={{ marginBottom: 48 }}
            />
          </Reveal>
          <div className="article-body">
            {post.content.map((para, i) => (
              <Reveal key={i} delay={i * 60}>
                <p>{para}</p>
              </Reveal>
            ))}
          </div>
          <Link
            to="/noutati"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              color: "var(--ce-teal)",
              fontWeight: 600,
              textDecoration: "none",
              marginTop: 24,
            }}
          >
            <ArrowLeft size={17} /> Înapoi la Noutăți
          </Link>

          {others.length > 0 && (
            <div style={{ marginTop: 80 }}>
              <h2 className="section-title" style={{ fontSize: "1.7rem" }}>
                Alte articole
              </h2>
              <div
                className="blog-grid"
                style={{ gridTemplateColumns: "repeat(2, 1fr)", marginTop: 32 }}
              >
                {others.map((p) => (
                  <Link key={p.id} to={`/noutati/${p.slug}`} className="blog-card">
                    <div className="blog-card-image">
                      <img src={p.image} alt={p.title} loading="lazy" />
                    </div>
                    <div className="blog-card-meta">{p.category}</div>
                    <h3 className="blog-card-title" style={{ fontSize: "1.1rem" }}>
                      {p.title}
                    </h3>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogPost;
